import React, { useCallback } from "react";
import { Platform } from "react-native";
import { FindMatchProps } from "./types";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { FindMatchProvider } from "./FindMatchContext";
import FindMatchContent from "./FindMatchContent";
import { useTranslation } from "react-i18next";
import useScreenOptionsHooks from "../../hooks/useScreenOptionsHooks";
import { useProductPrefix } from "../../hooks/useProductPrefix";
import { ThreeDPropertiesProvider } from "../../contexts/ThreeDPropertiesContext";
import { initializeFindMatchHeight } from "../../iframe/height/findMatchHeight";

type Props = {
  route?: FindMatchProps;
};

const FindMatchScreen = ({ route }: Props) => {
  const userInfo = useUserInfo();
  const navigation = useNavigation();
  const { t } = useTranslation();
  const productPrefix = useProductPrefix();
  const { theme, typography } = useScreenOptionsHooks();
  useFocusEffect(
    useCallback(() => {
      if (Platform.OS !== "web" || !userInfo.isIFrame()) return;
      return initializeFindMatchHeight();
    }, [userInfo])
  );
  return (
    <ThreeDPropertiesProvider>
      <FindMatchProvider
        route={route}
        userInfo={userInfo}
        navigation={navigation}
        t={t}
        theme={theme}
        typography={typography}
        productPrefix={productPrefix}
      >
        <FindMatchContent />
      </FindMatchProvider>
    </ThreeDPropertiesProvider>
  );
};

export default FindMatchScreen;
